import uniqueId from 'lodash/uniqueId';



export const POPUP_DESCRIPTION_OPEN = uniqueId('POPUP_DESCRIPTION_OPEN');
export const POPUP_DESCRIPTION_CLOSE = uniqueId('POPUP_DESCRIPTION_CLOSE');
export const SUBSCRIPTION_FORM_OPEN = uniqueId('SUBSCRIPTION_FORM_OPEN');
export const SUBSCRIPTION_FORM_CLOSE = uniqueId('SUBSCRIPTION_FORM_CLOSE');
export const POPUP_APP_SIZE_OPEN = uniqueId('POPUP_APP_SIZE_OPEN');
export const POPUP_APP_SIZE_CLOSE = uniqueId('POPUP_APP_SIZE_CLOSE');



// WEBPACK FOOTER //
// ./src/config/events.js